import React, { Component } from 'react';
import { Package, MapPin, Smartphone } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { WA_NUMBER } from '../data/products';
export function FinalCTA() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Vi el 20% OFF en AlphaFit y quiero saber más sobre los suplementos')}`;
  return <section className="bg-gradient-to-br from-[#1a1500] to-[#0d0d0d] py-[100px] px-5 text-center" data-id="element-125">
      <div className="max-w-[1100px] mx-auto" data-id="element-126">
        <h2 className="text-[clamp(2rem,5vw,3.5rem)] font-black uppercase tracking-[3px] mb-[15px] leading-[1.1] text-white" data-id="element-127">
          ¿Seguís Esperando o<br data-id="element-128" />
          <span className="text-alphaGold" data-id="element-129">Empezás Hoy?</span>
        </h2>

        <p className="text-[#aaa] text-[1.1rem] max-w-[600px] mx-auto mb-[40px] leading-[1.7]" data-id="element-130">
          Cada día que pasa es un entrenamiento sin el combustible que tu cuerpo
          merece. El 20% OFF no dura para siempre. Tu físico ideal no llega solo
          — pero con los suplementos correctos, llega mucho más rápido.
        </p>

        <div className="flex justify-center flex-wrap gap-4" data-id="element-131">
          <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 bg-whatsapp text-white text-[1rem] font-extrabold py-[18px] px-10 rounded uppercase tracking-[1px] transition-all duration-200 shadow-[0_6px_30px_rgba(37,211,102,0.35)] hover:-translate-y-[3px] hover:shadow-[0_10px_40px_rgba(37,211,102,0.5)]" data-id="element-132">
            <WhatsAppIcon className="w-[22px] h-[22px]" data-id="element-133" />
            Pedir por WhatsApp — 20% OFF
          </a>
        </div>

        <div className="flex items-center justify-center gap-4 flex-wrap text-[#444] text-[0.85rem] mt-[25px]" data-id="element-134">
          <span className="flex items-center gap-1.5" data-id="element-135">
            <Package className="w-4 h-4" data-id="element-136" /> Envío a domicilio desde $190 UY
          </span>
          <span className="hidden sm:inline" data-id="element-137">·</span>
          <span className="flex items-center gap-1.5" data-id="element-138">
            <MapPin className="w-4 h-4" data-id="element-139" /> Pick Up en Malvín
          </span>
          <span className="hidden sm:inline" data-id="element-140">·</span>
          <span className="flex items-center gap-1.5" data-id="element-141">
            <Smartphone className="w-4 h-4" data-id="element-142" /> +{WA_NUMBER.substring(0, 3)}{' '}
            {WA_NUMBER.substring(3, 5)} {WA_NUMBER.substring(5, 8)}{' '}
            {WA_NUMBER.substring(8)}
          </span>
        </div>
      </div>
    </section>;
}